import { render, staticRenderFns } from "./digitalTwin.vue?vue&type=template&id=48a2e01d&scoped=true"
import script from "./digitalTwin.vue?vue&type=script&lang=js"
export * from "./digitalTwin.vue?vue&type=script&lang=js"
import style0 from "./digitalTwin.vue?vue&type=style&index=0&id=48a2e01d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2e01d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a2e01d')) {
      api.createRecord('48a2e01d', component.options)
    } else {
      api.reload('48a2e01d', component.options)
    }
    module.hot.accept("./digitalTwin.vue?vue&type=template&id=48a2e01d&scoped=true", function () {
      api.rerender('48a2e01d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/digitalTwin.vue"
export default component.exports